import React from 'react';

/*
 * PROD-7828 — reusable status pill (plan A4 shared/status_pill.jsx).
 * Props-only, token-colored; safe to copy-adapt into teacher_web_app in Phase 2.
 */
const TONES = {
  gray: { bg: 'var(--surface-sunken)', text: 'var(--text-muted)' },
  green: { bg: 'var(--state-success-bg)', text: 'var(--state-success-text)' },
  red: { bg: 'var(--state-error-bg)', text: 'var(--state-error-text)' },
  orange: { bg: 'var(--state-warning-bg)', text: 'var(--state-warning-text)' },
  yellow: { bg: 'var(--state-warning-bg)', text: 'var(--state-warning-text)' },
  blue: { bg: 'var(--state-info-bg)', text: 'var(--state-info-text)' }
};

export const WAIVER_TONES = {
  NOT_WAIVED: 'gray',
  WAIVED: 'blue',
  FREE_PASS_APPLIED: 'green'
};

const StatusPill = ({ tone = 'gray', children }) => {
  const t = TONES[tone] || TONES.gray;
  return (
    <span className="tp-pill" style={{ background: t.bg, color: t.text }}>
      {children}
    </span>
  );
};

export default StatusPill;
